export enum DocumentEntityType {
  MyAbilitiAbsence = 0,
  Case,
  Referral,
  General
}
